module.exports = __webpack_public_path__ + "img/home2.71b8d490.jpg";